import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import EmergencyLeave_finance from "./Emergency_leave/EmergencyLeave";
import AnnualVacation_finance from "./Annual_vacation_finance/Annualvacatation_finance";
import Absconding_finance from "./Absconding_runaway/absconding";
import { useLocation } from "react-router-dom";
import nodeinstance from "../../../../nodeInstance";
import { setAppError } from "../../../../store/userSlice";

export default function Financedemobilize() {
  const location = useLocation();

  //screen Title Show fun
  const dispatch = useDispatch();

  const token = localStorage.getItem("nodeToken");

  const title = [
    { label: "DEMOBILIZATION", link: "/dashboard/demobilization" },
  ];

  const [index, setIndex] = useState(0);
  const [params, setParams] = useState();
  const handleIndex = (itemNumer, data) => {
    setIndex(itemNumer);
    setParams(data);
  };

  const [globalData, setGlobalData] = useState();
  const getEmployee_Finance = async () => {
    const param =
      index === 0
        ? "ERE-EMERGENCY LEAVE"
        : index === 1
          ? "ERE-ANNUAL VACATION"
          : "";
    const url =
      index === 0
        ? `/ere/getEmployees/${param}`
        : index === 1
          ? `/employeeAnnualvacation/getEmployees/${param}`
          : "";
    try {
      const response = await nodeinstance.get(`${url}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setGlobalData(response?.data);
      }
    } catch (error) {
      console.log("error to be printed here....", error);
      dispatch(
        setAppError({
          msg: "Failed to get the data",
        })
      );
    }
  };

  const [trigger, setTrigger] = useState(false);
  useEffect(() => {
    if (params === null || (params === undefined && index != 0)) {
      return;
    }
    getEmployee_Finance();
  }, [params, trigger]);

  return (
    <>
      <div className={`ml-5 mr-5 mt-4`}>
        <div className="{`flex flex-row-reverse p-10`}">
          <button
            onClick={() => handleIndex(0, "ERE-EMERGENCY LEAVE")}
            className={`p-2 h-10 text-black uppercase text-xs mr-2 rounded-md  ${index == 0 ? "bg-blue text-white" : "bg-white text-black"}`}
          >
            ERE - EMERGENCY LEAVE
          </button>
          <button
            onClick={() => handleIndex(1, "ERE-ANNUAL VACATION")}
            className={`p-2 h-10 text-black uppercase text-xs mr-2 rounded-md  ${index == 1 ? "bg-blue text-white" : "bg-white text-black"}`}
          >
            ERE - ANNUAL VACATION
          </button>
          <button
            onClick={() => handleIndex(2, "ABSCONDING-RUN AWAY")}
            className={`p-2 h-10 text-black uppercase text-xs mr-2 rounded-md  ${index == 2 ? "bg-blue text-white" : "bg-white text-black"}`}
          >
            ABSCONDING/RUN AWAY
          </button>
        </div>
        {index === 0 ? (
          <EmergencyLeave_finance
            globalData={globalData}
            setTrigger={setTrigger}
            trigger={trigger}
          />
        ) : index === 1 ? (
          <AnnualVacation_finance
            globalData={globalData}
            setTrigger={setTrigger}
            trigger={trigger}
          />
        ) : index === 2 ? (
          <Absconding_finance />
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
